import React from "react";
import { Box, Typography } from "@mui/material";

export interface MissingResourceBookJacket {
  title: string;
  width?: number;
  height?: number;
}

export const MissingResourceBookJacket: React.FC<MissingResourceBookJacket> = ({
  title,
  width,
  height,
}) => {
  return (
    <Box
      sx={{
        width: width ?? "100%",
        height: height ?? "100%",
        background: "var(--mui-palette-grey-300)",
        p: 1,
      }}
    >
      <Typography
        variant="caption"
        component="span"
        sx={{
          fontWeight: "bold",
          fontSize: "0.75rem",
          overflow: "hidden",
          textOverflow: "ellipsis",
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          maxHeight: "100%",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};
